import { ToggleButton, ToggleButtonGroup } from '@sunwebgroup/uds-ui/toggle-button'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import * as React from 'react'
import { useIntl } from '@/intl'
import styles from './FilterToggleGroup.module.css'

interface FilterToggleGroupProps<T extends string, CountKey extends string> {
  filter: T
  filters: {
    value: T
    label: string
    countKey: CountKey
  }[]
  counts: Record<CountKey, number>
  onFilterChange: (filter: T) => void
  size?: 'M' | 'S'
}

export function ToggleButtonGroupContainer({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn(styles.toggleButtonGroupContainer, className)} {...props}>
      {children}
    </div>
  )
}

export function FilterToggleGroup<T extends string, CountKey extends string>({
  filter,
  filters,
  counts,
  onFilterChange,
  size = 'M',
}: FilterToggleGroupProps<T, CountKey>) {
  const intl = useIntl()

  function handleValueChange(value: string) {
    if (value) {
      onFilterChange(value as T)
    }
  }

  return (
    <ToggleButtonGroup
      type="single"
      onValueChange={handleValueChange}
      value={filter}
      className={styles.toggleButtonGroup}
    >
      {filters.map(({ value, label, countKey }) => (
        <ToggleButton
          key={value.toString()}
          value={value}
          color="neutral"
          size={size}
          className={cn(styles.toggleButton, size === 'S' && styles.sizeS)}
        >
          <Typography>
            {intl.formatMessage({ id: label })}
          </Typography>
          <Typography variant="body-xs-bold-tight" className={styles.countBadge}>
            {counts[countKey]}
          </Typography>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
